export default __webpack_public_path__ + "static/media/Existing_Base.e0f91f62.jpg";